    export const tableColumns = [
        {
            Header: "No",
  

        },
        {
            Header: "Customer Name",
            accessor: "company.name",
        
        },
        {
            Header: "Invoice Remaining Amount (Unpaid)",
            accessor: "total_remaining",
            Cell: ({value}) => {
                if (value === null) return "-";
                return Number(value).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            }
       
        },
    ];